var _defs, _style, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _polygon5, _path3, _path4, _path5, _polygon6, _polygon7, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackbarLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 128.47 137",
    style: {
      width: 50,
      height: 50
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .cls-1 {\n      fill: #fff;\n    }\n  ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Back Bar Project logo seal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.37 38.1 37.59 52.99 37.59 54.03 50.17 54.03 86.39 45.73 86.39 42.94 74.37 38.1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.59 61.79 37.59 62.83 74.45 61.61 86.39 61.1 86.39 58.32 74.37 57.34 37.59 61.79"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.59 79.39 37.59 80.42 74.37 98.9 86.39 91.84 86.39 89.06 50.17 79.39 37.59 79.39"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.59 70.59 37.59 71.62 74.53 78.61 86.39 76.47 86.39 73.69 50.17 70.59 37.59 70.59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.87,42.25a2.49,2.49,0,0,0-1.4-1.42,2.94,2.94,0,0,0-4,1.75L0,46.1l10.53,4.3L12,46.81A3.67,3.67,0,0,0,10,42,3.38,3.38,0,0,0,6.87,42.25Zm-.32,4.06.58-1.4a1.41,1.41,0,0,1,2-.85,1.41,1.41,0,0,1,.83,2l-.58,1.41ZM5.1,44.08l-.58,1.41-1.63-.67.57-1.41a.81.81,0,0,1,1.16-.5A.81.81,0,0,1,5.1,44.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.89,22.44,19.27,33.3l1.64-1.74-.85-1.69,3.05-3.23,1.74.75,1.65-1.74L15.34,20.9ZM21,25.7l-2,2.1L17.09,24Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.77 0 58.06 0.24 56.14 3.59 55.86 0.44 53.59 0.63 54.59 11.96 56.86 11.76 56.47 7.32 57.02 6.39 60.38 11.45 63.02 11.22 58.32 4.18 60.77 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,8.84A3.14,3.14,0,0,1,37.67,9l.27.14L38.83,7l-.24-.11a5.54,5.54,0,0,0-4.41-.12,5.65,5.65,0,0,0-3.09,7.45,5.64,5.64,0,0,0,7.36,3.29,5.48,5.48,0,0,0,3.13-3.11l.1-.24-2.08-.9-.09.28a3.21,3.21,0,0,1-1.86,1.94,3.39,3.39,0,0,1-4.41-2.11A3.38,3.38,0,0,1,35,8.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,90.62,10.4,87.1.08,91.87l1,2.07,3.6-1.66.66,1.45a3.56,3.56,0,0,0,4.93,1.81A3.54,3.54,0,0,0,12,90.62ZM7.28,92.81l-.67-1.45,2.76-1.27L10,91.53a1.4,1.4,0,0,1-.76,2A1.39,1.39,0,0,1,7.28,92.81Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.61,132.11a5.78,5.78,0,1,0-3-7.49A5.65,5.65,0,0,0,38.61,132.11Zm3.58-8.66a3.6,3.6,0,1,1-4.43,2.06A3.34,3.34,0,0,1,42.19,123.45Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.11 127.77 91.46 126.37 90.62 124.35 87.27 125.76 86.36 123.58 91.02 121.63 90.18 119.61 83.41 122.45 87.8 132.93 94.66 130.06 93.81 128.04 89.06 130.04 88.11 127.77"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.15 93.31 118.18 94.14 119.11 91.86 127.61 95.35 128.47 93.24 119.97 89.75 120.91 87.48 118.89 86.65 116.15 93.31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.13,133c0,1.19-.49,1.79-1.47,1.79a1.45,1.45,0,0,1-1.47-1.56V133H60.91v.28A3.67,3.67,0,0,0,64.66,137c2.25,0,3.75-1.62,3.75-4v-7.43H66.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.11,109.87a3.14,3.14,0,0,1,2.51-1l.3,0v-2.26h-.27a5.47,5.47,0,0,0-4.08,1.66,5.78,5.78,0,0,0,8.2,8.14,5.48,5.48,0,0,0,1.62-4.1v-.27h-2.26l0,.3a3.17,3.17,0,0,1-.93,2.52,3.6,3.6,0,0,1-5.1-5.06Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,119.65l1.56-4.6a3.71,3.71,0,0,0,3.83-6.11l-2.71-2.73-8.07,8,1.52,1.53,2.84-2.83.81.81L17.29,118Zm2.74-10.46,1.19,1.2a1.62,1.62,0,0,1-2.3,2.29l-1.19-1.21Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.87,11.85a2.55,2.55,0,0,0,1.42-1.4,3,3,0,0,0-1.76-4L90,5,85.72,15.51,89.31,17a3.68,3.68,0,0,0,4.86-2A3.41,3.41,0,0,0,93.87,11.85Zm-4.07-.32,1.41.58a1.4,1.4,0,0,1,.84,2,1.41,1.41,0,0,1-2,.83l-1.41-.58ZM92,10.08l-1.41-.57.67-1.64,1.4.57a.8.8,0,0,1,.5,1.16A.8.8,0,0,1,92,10.08Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,20.36,102.15,24.9l1.61,1.77,1.75-.71,3,3.28-.88,1.67,1.61,1.77,5.58-10.76ZM109.6,27.2l-1.95-2.15,3.93-1.62Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.89,49.82l3.17-3.68a3.71,3.71,0,0,0,5.84-4.23l-1.49-3.55-10.48,4.4.83,2,3.7-1.56.44,1.05L118,47.64Zm6.45-8.68.66,1.57A1.62,1.62,0,0,1,123,44l-.66-1.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbarLogoWhite);
export default __webpack_public_path__ + "static/media/backbar-logo-white.d19c7c424bd91c06d07e6f5b889a1e67.svg";
export { ForwardRef as ReactComponent };